export function pct(value, decimals, skipLessThan, trimZeroes) {
  decimals = decimals || 0;
  if (!skipLessThan && value * 100 < 0.1 && value * 100 > 0) {
    return `<span class="less-than"><</span>0.1%`;
  } else if (value * 100 < 1 && value * 100 > 0) {

    // Check for sig digits
    // let sigDigits = 3;
    // if ((value / .00001) % 10 === 0) {
    //   sigDigits = 2;
    // }
    // if ((value / .0001) % 10 === 0) {
    //   sigDigits = 1;
    // }

    let sigDigits = 1;

    let display = (value * 100).toFixed(sigDigits);
    display += '%';

    if (trimZeroes) {
      display = display.replace(/[0]+%/gi, '%');
    }
    return `${ display }`;
  } else {
    let display = (value * 100).toFixed(decimals);
    if (trimZeroes) {
      display = display.replace(/\.0/gi, '');
    }
    return `${ display }%`;
  }
}

export function pad(n) {
  return (n < 10 ? '0' : '') + n;
}

export function getNumberWithOrdinal(n) {
  let s = ["th", "st", "nd", "rd"],
    v = n % 100;
  return n + (s[(v - 20) % 10] || s[v] || s[0]);
}

export function groupBy(xs, key) {
  return xs.reduce((rv, x) => {
    (rv[x[key]] = rv[x[key]] || []).push(x);
    return rv;
  }, {});
}


export function isBetween(value, start, end) {
  if (value >= start && value <= end) {
    return true;
  } else {
    return false;
  }
}

export function getLastItem(arr) {
  return arr[arr.length - 1];
}

export function getQueryVariable(variable) {
  let query = window.location.search.substring(1);
  let vars = query.split('&');
  for (let i = 0; i < vars.length; i++) {
    let pair = vars[i].split('=');
    if (decodeURIComponent(pair[0]) === variable) {

      let uri = decodeURIComponent(pair[1]);

      // This is some absolute trash-fire nonsense, but new URL(), used to construct these,
      // encodes spaces ' ' as '+', which, while loosely supported in browsers,
      // doesn't follow specs (see comments in https://stackoverflow.com/questions/2678551/when-should-space-be-encoded-to-plus-or-20)
      // Likewise, decodeURIComponent and decodeURI won't decode '+' back to a space.
      // So, we bolt on this silly replace to get them to be spaces again.
      uri = uri.replace(/\+/gi, ' ');

      return uri;
    }
  }
  console.log('Query variable %s not found', variable);
}

export function getOffset(element)
{
  if (!element.getClientRects().length)
  {
    return { top: 0, left: 0 };
  }

  let rect = element.getBoundingClientRect();
  let win = element.ownerDocument.defaultView;
  return (
    {
      top: rect.top + win.pageYOffset,
      left: rect.left + win.pageXOffset
    });
}
